/**
 *
 * 并行请求，单个promise无论结果是否异常，都不影响其他promise请求
 */

export function concurrency<T extends unknown[] | []>(
  promises: T,
): Promise<{ [P in keyof T]: Awaited<T[P]> }> {
  // 创建一个空数组来存储结果
  const results = [] as any;

  // 创建一个计数器，用于跟踪完成的任务数
  let completed = 0;

  return new Promise(resolve => {
    // 遍历所有任务
    promises.forEach((promise, index) => {
      // 使用Promise.resolve将任务包装为一个Promise
      Promise.resolve(promise)
        .then(result => {
          // 将结果添加到结果数组中
          results[index] = result;
        })
        .catch(() => {
          //   results[index] = err
        })
        .finally(() => {
          // 每次完成一个任务，计数器加1
          completed++;

          // 如果所有任务都已完成，则返回结果数组
          if (completed === promises.length) {
            resolve(results);
          }
        });
    });
  });
}
